// vuex数据
import store from "@/store";
import { toNumber } from "xe-utils";
// 提示
import { Notification } from "element-ui";
// 切换楼层/绘制整栋
import { changeFloor, drawTotalFloor } from "@/rlMxModules/operate/init";
import { changeFloorC } from "@/rlMxModules/operate/initC";
// 更新三维视图
import { update3Dview } from "@/rlMxModules/threeObject/threeView";
// 本地indexedDB操作
import {
  getrlFloor,
  resetAllRlFloor,
  delrlStdFlr,
} from "@/mixins/LiteModuleDb.js";
import { delFloorDetectionData } from "@/rlMxModules/operate/operateApi";
import { FullView } from "@/views/inspectionLite/components/ModulePage/utils/viewChange";
// --- 判断当前页面是否为整栋 ---
export const isWhole = () => {
  var wholeBol = store.state.detectionModule.rl_floor_id == -999;
  return wholeBol;
};

// --- 重新获取标准层/自然层数据 ---
export const getPageFloorList = async (initBol) => {
  const res = await store.dispatch("globalData/getFloorArr");
  // 如果是初始化
  if (initBol) {
    // 获取存储在本地存储中的数据 刷新后楼层复现
    const locals = JSON.parse(localStorage.getItem("vuex"));
    var localFloorId = locals.detectionModule.rl_floor_id;
    const targetObject = res.find((item) => item.Guid == localFloorId);
    await changeFloorSrd(targetObject || res[0]);
  }
  return res;
};

//重新获取所有楼层的数据
export const getPageAllFloorList = async (initBol) => {
  const res = await store.dispatch("globalData/getFloorArr");

  // 如果是初始化
  if (initBol) {
    // 获取存储在本地存储中的数据 刷新后楼层复现
    const locals = JSON.parse(localStorage.getItem("vuex"));
    var localFloorId = locals.detectionModule.rl_floor_id;
    const targetObject = res.find((item) => item.Guid == localFloorId);

    if (res.length > 1) {
      for (let i = 1; i < res.length; i++) {
        await changeFloorSrd(res[i]);
      }
    }
    await changeFloorSrd(targetObject || res[0]);
  }
  return res;
};

// --- 切换楼层时 存储当前guid值(传自然层数据) ---
export const setFloorState = (obj) => {
  try {
    // 存储标准层数据及自然层id
    store.commit(
      "globalData/setStdFlr",
      obj.Guid == -999 ? -999 : obj.StdFlrGuid
    );
    store.commit("detectionModule/SET_FloorId", obj.Guid);
    // 保留原来的楼栋数据
    store.commit("cadModules/set_rlBuilding", obj);
  } catch (error) {}
};
// --- 切换标准层/自然层(传自然层数据) ---
export const changeFloorSrd = async (
  obj,
  originHeight = null /* 新增不同层高的楼层或者修改楼层高度 */,
  originLevelB = null
) => {
  try {
    // 存数据
    setFloorState(obj);

    // 检查stdFlrGuid是否有效
    const stdFlrGuid = obj.StdFlrGuid || obj.Guid;
    if (obj.Guid !== -999 && (!stdFlrGuid || stdFlrGuid === undefined)) {
      console.error("changeFloorSrd: 无效的标准层ID", obj);
      return;
    }

    // 绘制界面
    obj.Guid == -999
      ? await drawAllFloor()
      : await changeFloor(stdFlrGuid, originHeight, originLevelB);
    if (getCheckStatus(25)) {
      //这里为了重新渲染检测
      await setCheckText(true);
    } else {
      // 更新三维场景
      await update3Dview();
    }

    FullView();
  } catch (error) {
    console.error("切换楼层出错:", error);
  }
};
export function getCheckStatus(guid) {
  return store.state.displayData.rlLayerDisplay.includes(guid);
}
//控制显示构件的检测文字(墙梁板柱)
export async function setCheckText(bol) {
  const {
    gridData, // 网格
    colsegData, // 柱
    constructionColData, // 构造柱
    beamsegData, // 梁
    wallsegData, // 墙
    slabData, // 板
    ringBeamData, // 圈梁
    subBeamData, // 次梁
  } = get_structural_data();
  const isShowWall = getCheckStatus(6);
  const isShowBeam = getCheckStatus(5);
  const isShowSubBeam = getCheckStatus(9);
  const isShowRingBeam = getCheckStatus(8);
  const isShowConstrColumns = getCheckStatus(26);
  const isShowColumns = getCheckStatus(4);
  const isShowSlab = getCheckStatus(7);
  if (wallsegData && ((bol && isShowWall) || !bol)) {
    for (let i = 0; i < wallsegData.length; i++) {
      await wallsegData[i].m_gridData.drawCheckText();
    }
  }
  if (beamsegData && ((bol && isShowBeam) || !bol)) {
    for (let i = 0; i < beamsegData.length; i++) {
      await beamsegData[i].m_gridData.drawCheckText();
    }
  }
  if (ringBeamData && ((bol && isShowRingBeam) || !bol)) {
    for (let i = 0; i < ringBeamData.length; i++) {
      await ringBeamData[i].m_gridData.drawCheckText();
    }
  }
  if (subBeamData && ((bol && isShowSubBeam) || !bol)) {
    for (let i = 0; i < subBeamData.length; i++) {
      await subBeamData[i].m_gridData.drawCheckText();
    }
  }
  if (gridData && ((bol && (isShowBeam || isShowWall)) || !bol)) {
    for (let i = 0; i < gridData.length; i++) {
      await gridData[i].drawCheckText();
    }
  }
  if (colsegData && ((bol && isShowColumns) || !bol)) {
    for (let i = 0; i < colsegData.length; i++) {
      await colsegData[i].drawCheckText();
    }
  }
  if (constructionColData && ((bol && isShowConstrColumns) || !bol)) {
    for (let i = 0; i < constructionColData.length; i++) {
      await constructionColData[i].drawCheckText();
    }
  }
  if (slabData && ((bol && isShowSlab) || !bol)) {
    for (let i = 0; i < slabData.length; i++) {
      slabData[i] &&
        slabData[i].drawCheckText &&
        (await slabData[i].drawCheckText());
    }
  }
  rlAppObj._rlMx.MxFun.updateDisplay();
  rlAppObj.rlMxDrawObject.updateDisplay();
  // 更新三维场景
  update3Dview();
}
// --- 切换标准层/自然层(传自然层数据) 草图---
export const changeFloorSrdC = async (
  obj,
  originHeight = null /* 新增不同层高的楼层或者修改楼层高度 */,
  originLevelB = null
) => {
  try {
    // 存数据
    setFloorState(obj);

    // 检查stdFlrGuid是否有效
    const stdFlrGuid = obj.StdFlrGuid || obj.Guid;
    if (obj.Guid !== -999 && (!stdFlrGuid || stdFlrGuid === undefined)) {
      console.error("changeFloorSrd: 无效的标准层ID", obj);
      return;
    }

    // 绘制界面
    await changeFloorC(stdFlrGuid, originHeight, originLevelB);
    // 更新三维场景
    await update3Dview();
    FullView();
  } catch (error) {
    console.error("切换楼层出错:", error);
  }
};
// --- 绘制整栋 ---
export const drawAllFloor = async () => {
  // 绘制整栋数据
  // await drawTotalFloor();
  // 切换为三维视角
  store.commit("globalData/setIsBldg", true); // 绘制整栋数据
  store.commit("drawModules/setViewFlag", true);
  store.commit("inspectionStore/setbottomShow", false);

  // 提示
  Notification({
    title: "警告",
    message: "整栋状态仅可查看三维",
    type: "warning",
  });
};
// --- 根据楼层对象、点击的构件对象返回构件号 ---
export const PartNumberNaming = (build, part) => {
  const SecondName = function (value) {
    switch (value) {
      case "rlColSeg":
        return "柱";
      case "rlWallSeg":
        return "墙";
      case "rlBeamSeg":
        return "梁";
      case "rlSlab":
        return "板";
      case "rlRingBeamSeg":
        return "圈梁";
      case "rlSubBeam":
        return "次梁";
      case "rlWallHole":
        return "墙洞";
      case "rlPartitionWallSeg":
        return "隔墙";
    }
  };
  // const ThirdName = part.ModelNo
  //   ? part.ModelNo
  //   : part.No_
  //   ? part.No_
  //   : part.Guid;
  const ThirdName =
    part && part.ModelNo
      ? part.ModelNo
      : part && part.m_useType === "RoomName"
      ? ""
      : "空";
  const newName =
    build.Name +
    "·" +
    (SecondName(part && part.classTypeName) ||
      (part && part.m_useType === "RoomName" ? part.useFunctionName : "")) +
    (ThirdName ? "·" : "") +
    ThirdName;
  return newName;
};

// ---------------- 构件显隐 -----------------
// 传入需要展示的构件类名 其他则隐藏
import { get_structural_data } from "@/rlMxModules/operate/index";
// --- 构件显隐(主要方法) ---
export function setConstructVisible(key) {
  /**
   * 全部 'all'/点 1/轴线 2/网格 3/柱 4/梁 5/墙 6/板 7/圈梁 8/次梁 9/墙洞 10/文字 11
   */
  const {
    jointData,
    colsegData,
    beamsegData,
    wallsegData,
    axisData,
    gridData,
    slabData,
    ringBeamData,
    subBeamData,
    wallHoleData,
    textAppData,
  } = get_structural_data();
  const allConstructModule = [
    {
      sGuid: 1,
      label: "点",
      children: jointData || [],
    },
    {
      sGuid: 2,
      label: "轴线",
      children: axisData || [],
    },
    {
      sGuid: 3,
      label: "网格",
      children: gridData || [],
    },
    {
      sGuid: 4,
      label: "柱",
      children: colsegData || [],
    },
    {
      sGuid: 5,
      label: "梁",
      children: beamsegData || [],
    },
    {
      sGuid: 6,
      label: "墙",
      children: wallsegData || [],
    },
    {
      sGuid: 7,
      label: "板",
      children: slabData || [],
    },
    {
      sGuid: 8,
      label: "圈梁",
      children: ringBeamData || [],
    },
    {
      sGuid: 9,
      label: "次梁",
      children: subBeamData || [],
    },
    {
      sGuid: 10,
      label: "墙洞",
      children: wallHoleData || [],
    },
    {
      sGuid: 11,
      label: "文字",
      children: textAppData || [],
    },
  ];
  return new Promise(async (resolve, reject) => {
    allConstructModule.map(async (item) => {
      await setVisible(
        item.children,
        !!(key.includes(item.sGuid) || key.includes("all"))
      );
    });
    await rlAppObj._rlMx.MxFun.updateDisplay();
    await rlAppObj.rlMxDrawObject.updateDisplay();
    // 更新三维场景
    update3Dview();

    store.commit("detectionModule/SET_VisNmb");
    resolve("显示成功");
  });
}
// --- 构件显隐绘制 ---
async function setVisible(arr, bol) {
  if (arr.length > 0) {
    arr.map(async (m) => {
      if (m.classTypeName == "rlAxis") {
        await m.showAxisName(bol);
      }
      m.mcDbId.getMcDbEntity().visible = bol;
      // 文字对象跟随构件显隐
      if (m.componentType) {
        if (m.m_TextObj) m.m_TextObj.visible = bol;
      }
    });
    await rlAppObj._rlMx.MxFun.updateDisplay();
    await rlAppObj.rlMxDrawObject.updateDisplay();
    // 更新三维场景
    update3Dview();
  }
}
// 视图全图转换
export const viewChangeZoomW = () => {
  // 2D全图
  rlAppObj.mxcadObject.zoomAll();
  rlAppObj.mxcadObject.zoomScale(0.7);

  // 3D全图
  if (rlThreeObj.Tscene.children.length > 0) {
    // 创建一个新的包围盒
    const boundingBox = new THREE.Box3();

    // 遍历所有的子对象
    for (let i = 0; i < rlThreeObj.Tscene.children.length; i++) {
      // 计算子对象的包围盒并合并到总的包围盒中
      boundingBox.expandByObject(rlThreeObj.Tscene.children[i]);
    }
    // 获取包围盒的中心点
    const center = boundingBox.getCenter(new THREE.Vector3());
    // 将控制器的目标点设置为包围盒的中心点
    rlThreeObj.Tcontrols.target.copy(center);
    // 获取包围盒的大小
    const size = boundingBox.getSize(new THREE.Vector3());
    // 设置相机的位置
    rlThreeObj.Tcamera.position.set(
      center.x,
      center.y + size.y * 1.5, // 高度
      center.z + size.z * 1.5 // 距离
    );
  }

  // 更新视图
  rlAppObj.rlMxDrawObject.updateDisplay();
};

// 重置数据计算底标高
export const getBottomElevation = async (newFloor) => {
  // 过滤掉整栋
  const nonWholeBuildingRecords = newFloor.filter(
    (record) => record.No_ !== "-999"
  );
  // 重新排序
  nonWholeBuildingRecords.sort((a, b) => a.No_ - b.No_);
  // 计算底标高
  var OneHeight = 0;
  newFloor.forEach((item) => {
    if (item.No_ == 1) {
      OneHeight = toNumber(item.LevelB);
    }
  });
  nonWholeBuildingRecords.forEach((record) => {
    // 大于等于1层时
    if (record.No_ >= 1) {
      var cacheList = newFloor.filter(
        (meter) => meter.No_ > 0 && meter.No_ < record.No_
      );
      if (cacheList.length > 0) {
        var HeightTotal = cacheList.reduce(function (prev, cur) {
          return toNumber(cur.Height) + prev;
        }, 0);
        record.LevelB = HeightTotal + OneHeight;
      } else {
        record.LevelB = OneHeight;
      }
    } else {
      var cacheList = newFloor.filter(
        (meter) => meter.No_ < 0 && meter.No_ > record.No_ - 1
      );
      var HeightTotal = cacheList.reduce(function (prev, cur) {
        return toNumber(cur.Height) + prev;
      }, 0);
      record.LevelB = OneHeight - HeightTotal;
    }
  });
  const wholeBuildingRecord = newFloor.find((record) => record.No_ === "-999");
  const result = wholeBuildingRecord
    ? [wholeBuildingRecord, ...nonWholeBuildingRecords]
    : nonWholeBuildingRecords;
  return result;
};

// 删除自然层-同步删除对应标准层(传对应自然层数据)
export const delNatureFloor = async (nature) => {
  var floorArr = await getrlFloor();
  floorArr = await floorArr.filter((item) => item.Guid != nature.Guid);

  // 删除楼层中的检测数据
  if (await delFloorDetectionData(nature.Guid, nature.No_)) {
    // 计算底标高
    var getNatue = await getBottomElevation(floorArr);

    // 删除对应标准层
    await delrlStdFlr(nature.StdFlrGuid);
    // 重置自然层数据
    await resetAllRlFloor(getNatue);

    // 重新更新vuex数据
    await store.dispatch("globalData/getStdFlrArr");
    await store.dispatch("globalData/getFloorArr");
    return true;
  } else {
    return false;
  }
};
